<compass-pois-table [poisTableList]="placesList" style="width: 100%;">
</compass-pois-table>